import { productMetaData } from "~/route-containers/product.container";
import Component from "~/route-containers/partner/product/additional-content/additional-content.container";
export { productMetaData as meta };

export default Component;
